import React, {Component} from 'react';
import {connect} from 'react-redux'
import {history} from "../app/App";
import {registrationAction} from "../../actions/registrationAction";
import {default as LOCALE} from "../../localization";
import {userConstants} from "../../constants/userConstants";

class OtpVerifyRegistration extends Component {

    constructor(props) {
        super(props);
        this.state = {
            otpCode: '',
            seconds: 90,
            fieldEmpty: false,
        };
    }

    componentDidMount() {
        this.timeoutCounter = setInterval(() => {

            const {verifyingOTP} = this.props.otpVerifyRegisterReducer;

            if (verifyingOTP) {
                return;
            }

            const {seconds} = this.state;

            if (seconds <= 0) {
                clearInterval(this.timeoutCounter);
                history.goBack();
            }

            this.setState(({seconds}) => ({
                seconds: seconds - 1
            }));

        }, 1000);
    }

    getRemainingTime = () => {
        const minutes = Math.trunc(this.state.seconds / 60);
        let seconds = this.state.seconds % 60;

        seconds = seconds < 10 ? `0${seconds}` : seconds;

        console.log('min=', minutes);
        console.log('sec=', seconds);
        return `${minutes}:${seconds}`
    };


    componentWillUnmount() {
        clearInterval(this.timeoutCounter);
    }

    onInput = (e) => {
        const {name, value} = e.target;
        this.setState({[name]: value});
    };

    verifyOtpRegistration = (e) => {
        e.preventDefault();

        console.log('verifyOTP');

        const {otpCode} = this.state;
        if (otpCode.length === 0) {
            this.setState({fieldEmpty: true});
            return;
        }

        this.setState({fieldEmpty: false});

        const insertId = this.props.otpRequestRegisterReducer.responseData.insertId;

        this.props.verifyOtpRegistration(otpCode, insertId);
    };

    render() {
        LOCALE.setLanguage(localStorage.getItem(userConstants.LANGUAGE_DEFAULT));
        const prevResponse = this.props.otpRequestRegisterReducer.responseData.message;
        const {verifyingOTP, invalidData, internalError, errorMessage} = this.props.otpVerifyRegisterReducer;
        const {fieldEmpty, otpCode} = this.state;

        return (
            <div className="login-page">
                <div className="login-form">

                    <div className="code-sent-msg">
                        {prevResponse}
                    </div>

                    <button className='btn01' onClick={() => {
                        history.goBack()
                    }}>{LOCALE.edit_email}
                    </button>

                    <h4>{LOCALE.time_remaining} {this.getRemainingTime()}</h4>

                    <div>
                        <div className="top-space forgot-msg">
                            {fieldEmpty && <div>{LOCALE.enter_otp_to_continue}</div>}
                            {invalidData && <div>{errorMessage}</div>}
                            {internalError && <div>{LOCALE.internal_error}</div>}
                        </div>

                        <input disabled={verifyingOTP}
                               className={fieldEmpty || internalError || invalidData ? "input-field input-field-error" : "input-field"}
                               type='number'
                               name='otpCode'
                               value={otpCode}
                               placeholder={LOCALE.enter_otp}
                               onChange={this.onInput}/><br/>

                        <button className="btn1" disabled={verifyingOTP}
                                onClick={this.verifyOtpRegistration}> {verifyingOTP ? "" :LOCALE.verify} </button>

                        {verifyingOTP && <div className="lds-dual-ring"/>}

                        <br/>

                        <div>{LOCALE.back_to_login}
                            <button className="btn-clear top-space"
                                    onClick={() => {
                                        history.goBack();
                                        history.goBack()
                                    }}><strong>{LOCALE.click_here}</strong>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const actionCreators = {
    verifyOtpRegistration: registrationAction.verifyOtpRegistration
};


const mapState = (state) => {
    return {
        otpRequestRegisterReducer: state.otpRequestRegisterReducer,
        otpVerifyRegisterReducer: state.otpVerifyRegisterReducer
    };
};

export default connect(mapState, actionCreators)(OtpVerifyRegistration);
